import React, { useContext } from 'react';
import { useLocation, useParams } from 'react-router';
import { shallowEqual } from 'react-redux';

import LoadableComponentErrorBoundary from '../components/LoadableComponentErrorBoundary/LoadableComponentErrorBoundary';
import NamedRedirect from '../components/NamedRedirect/NamedRedirect';
import { ContextProvider } from '../ContextProvider';
import useAppSelector from '../util/hooks/useAppSelector';

const PageWrapper = ({ route }) => {
  const location = useLocation();
  const params = useParams();
  const ssrContext = useContext(ContextProvider);
  const { isAuthenticated } = useAppSelector(
    (state) => ({ isAuthenticated: state.auth.isAuthenticated }),
    shallowEqual
  );
  const { component: PageComponent, auth, authPage = 'SigninPage', extraProps } = route;

  // Auth check — needed for SSR (where loaders are skipped) and edge cases
  // (e.g., session expires without navigation). On client navigation,
  // the loader in dataRouter.js handles auth redirect before render.
  const canShow = !auth || isAuthenticated;

  if (!canShow) {
    if (ssrContext && typeof ssrContext === 'object') {
      ssrContext.unauthorized = true;
    }
    return (
      <NamedRedirect
        name={authPage}
        state={{ from: `${location.pathname}${location.search}${location.hash}` }}
      />
    );
  }

  return (
    <LoadableComponentErrorBoundary>
      <PageComponent
        location={location}
        params={params}
        ssrContext={ssrContext}
        {...extraProps}
      />
    </LoadableComponentErrorBoundary>
  );
};

PageWrapper.displayName = 'PageWrapper';

export default PageWrapper;
